export default __webpack_public_path__ + "static/media/cart.e4e6bcb7.svg";